
export enum OrigenMovimientoSaldoUsuarioZE {
    EntregaIngresos = 0,
    CancelacionEntregaIngresos = 1,
    LiberacionDeEntrega = 2
}

/**Este view representa los movimientos de zona extendida que afectan el saldo del UsuarioZE */
export interface SaldosUsuariosZEView {
    /**Es el id del origen de este movimiento ya se  */
    TipoOrigen: OrigenMovimientoSaldoUsuarioZE;

    /**Nota: Esta columna no esta diseñada para ser utulizada en la logica solamente se usa para darle una llave unica al registro */
    IdOrigen: number;

    /**Usuario de zona extendida a quien afecta el movimiento */
    IdUsuarioZE: number;

    /**Fecha en la que se realizó este movimiento */
    Fecha: Date | string;

    /**Movimiento de entrega de ingresos a usuarios si este movimiento proviene de una entrega de ingresos a usuario si no es null */
    IdEntregaIngresosAUsuario: number | null;

    /**Cancelación de una entrega de ingresos a usuario si este movimiento proviene de una cancelación de ingresos de un usuariode lo contrario es null */
    IdCancelacionEntregaIngresoAUsuario: number | null;

    /**Liberación de entregas de ZE en caso de que este movimiento provenga de una liberación de entregas de ZE si no es null */
    IdLiberacionEntregaZE: number | null;

    /**Es el importe que representa este movimiento de saldo de usuario de ZE */
    Importe: number;

    /**Representa el saldo acumulado del usuario */
    Saldo: number;

    UsuarioCapturo: string;
}

export interface SaldosUsuariosZEViewDTO extends SaldosUsuariosZEView {
    NombreUsuarioZE: string;
    
}


export interface FiltroSaldosUsuariosZE {
    IdUsuarioZE?: number | null;
    FechaDesde?: Date | string | null;
    FechaHasta?: Date | string | null;
    TipoOrigen?: OrigenMovimientoSaldoUsuarioZE | null;
}


// WEBPACK FOOTER //
// ./app/models/saldosusuarioszeview.ts